import React from 'react';
import { Connection, Workflow } from '../../../types/workflow';

const CATEGORY_ORDER: Array<{ key: Connection['category']; label: string }> = [
  { key: 'database',     label: 'Databases' },
  { key: 'mcp',          label: 'MCPs' },
  { key: 'api',          label: 'APIs' },
  { key: 'intake',       label: 'Intake channels' },
  { key: 'ai-provider',  label: 'AI providers' },
  { key: 'human-queue',  label: 'Human queues' },
  { key: 'storage',      label: 'Storage' },
  { key: 'identity',     label: 'Identity' },
];

function uptimeColor(pct: number) {
  if (pct >= 99.95) return '#0F6E56';
  if (pct >= 99.5)  return '#92400e';
  return '#b91c1c';
}

export function ConnectionsTab({ workflow }: { workflow: Workflow }) {
  const byCat = new Map<Connection['category'], Connection[]>();
  for (const c of workflow.connections) {
    if (!byCat.has(c.category)) byCat.set(c.category, []);
    byCat.get(c.category)!.push(c);
  }

  return (
    <div className="space-y-6">
      {CATEGORY_ORDER.filter(c => byCat.has(c.key)).map(group => (
        <section key={group.key} className="bg-white border border-trim rounded-xl overflow-hidden">
          <div className="px-5 py-3 border-b border-trim flex items-center justify-between">
            <h3 className="text-sm font-semibold text-ink">{group.label}</h3>
            <span className="text-xs text-muted">{byCat.get(group.key)!.length} {byCat.get(group.key)!.length === 1 ? 'connection' : 'connections'}</span>
          </div>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-trim bg-wash">
                <th className="text-left px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Name</th>
                <th className="text-left px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Type</th>
                <th className="text-left px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Auth</th>
                <th className="text-left px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Owner</th>
                <th className="text-right px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Latency</th>
                <th className="text-right px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Uptime</th>
                <th className="text-left px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Last success</th>
                <th className="text-left px-5 py-2 text-xs font-semibold uppercase tracking-wide text-muted">Rate limit</th>
              </tr>
            </thead>
            <tbody>
              {byCat.get(group.key)!.map(c => (
                <tr key={c.id} className="border-b border-wash last:border-0">
                  <td className="px-5 py-2.5 text-ink font-medium">{c.name}</td>
                  <td className="px-5 py-2.5 text-copy text-xs">{c.type}</td>
                  <td className="px-5 py-2.5 text-copy text-xs">{c.authentication_type}</td>
                  <td className="px-5 py-2.5 text-copy text-xs">{c.owner}</td>
                  <td className="px-5 py-2.5 text-right text-copy font-mono text-xs">{c.latency_ms}ms</td>
                  <td className="px-5 py-2.5 text-right font-mono text-xs" style={{ color: uptimeColor(c.uptime_pct) }}>{c.uptime_pct.toFixed(2)}%</td>
                  <td className="px-5 py-2.5 text-muted text-xs">{new Date(c.last_success).toLocaleTimeString()}</td>
                  <td className="px-5 py-2.5 text-muted text-xs">{c.rate_limits}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  );
}
